import React, { Component, Fragment } from 'react';
import { Select } from 'antd';
import cx from 'classnames';
import { find } from 'lodash';
import './Select.scss';

const Option = Select.Option;

class CustomSelect extends Component {
  render() {
    const {
      className,
      list,
      isTable,
      isEditable = true,
      value,
      size = 'large',
      setRef,
      dropdownClassName,
      ...res
    } = this.props;
    const setPopupContainer = (triggernode) => {
      return isTable ? document.getElementById('page-template-main') : triggernode.parentNode;
    };

    return (
      <Fragment>
        {isEditable ? (
          <Select
            className={cx('amondz-select', className, { isTable: isTable })}
            value={value ?? ''}
            size={size}
            disabled={!isEditable}
            ref={setRef}
            popupClassName={dropdownClassName}
            {...res}
            getPopupContainer={setPopupContainer}
          >
            {list.map((data) => (
              <Option key={data.id ?? `null-${data.name}`} value={data.id ?? ''} disabled={data.disabled}>
                {data.name}
              </Option>
            ))}
          </Select>
        ) : (
          <div>
            {list.length
              ? find(list, (item) => item.id === value)
                ? find(list, (item) => item.id === value).name
                : null
              : null}
          </div>
        )}
      </Fragment>
    );
  }
}

export default CustomSelect;
